import { NavHelper, NavTypes } from './nav';

export class TermsOfUsage {
    public static setEventListeners() {
        const termsOfUsageCloseButtonEl: Element = document.getElementsByClassName('js-terms-close-button')[0];
        const termsOfUsageOpenButtonEl: Element = document.getElementsByClassName('js-terms-open-button')[0];

        termsOfUsageOpenButtonEl.addEventListener('click', () => {
            NavHelper.selectNavByName(NavTypes.TermsOfUsage, true);
        });

        termsOfUsageCloseButtonEl.addEventListener('click', () => {
            NavHelper.selectNavByName(NavHelper.isPatternContext ? NavTypes.Pattern : NavTypes.Product, true);
        });
    }
}

TermsOfUsage.setEventListeners();